// Core
import React, { Component } from 'react';
import '../styles/styles.scss';

// Imports
import Spinner from 'react-bootstrap/Spinner';
import Header from '../components/header';

// Pages
import SurveyUnsub from '../components/surveyunsub';
import Error from './Error'
import { getEmailByToken, getCategories } from '../Functions';

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data : [],
      categories: [],
      category: this.props.query.category,
      loading : true,
      error : false,
      hasResults : false,
      email : "",
      token : this.props.query.token,
    }
  }

  async componentDidMount() {
    const categories = await Promise.all([
      this.fetchCategories()
    ]);

    const token = await this.checkToken();

    const error = token == null ? true : false;

    this.setState({
      email : token,
      categories : categories
    });

    this.setState({ error : error, loading : false });
  }

  async fetchCategories() {
    let categories = await getCategories().then(resp => {
      return resp;
    });

    if (categories.data == null || categories.data.err) {
			return null;
    }

    if (categories.data.length) {
      return categories.data;
    }
  }

  async checkToken() {
    let tokenResponse = await getEmailByToken(this.state.token).then(resp => {
      return resp;
    });

    if (tokenResponse.data.addressValue == null || tokenResponse.data.err) {
			return null;
    }

    if (tokenResponse.data) {
      let email = tokenResponse.data.addressValue.toLowerCase();
      return email;
    }
  }

  render() {
    if (this.state.error) {
      return(
        <>
          <Header />
          <Error message="An Error Occured" subMessage="There was an error processing your email token, please try again later." />
        </>
      );
    }

    else if (!this.state.loading) {
      return (
        <>
          <Header />
          <div className="outer-container">
            <span className="pref-container">
              <SurveyUnsub email={this.state.email} categories={this.state.categories} category={this.state.category} />
            </span>
          </div>
        </>
      );
    }

    else {
      return(
        <>
          <Spinner animation="border" role="status" id="spinner" size="sm">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </>
      );
    }
  }
}

export default Survey;